import { render, staticRenderFns } from "./inc_person_step_4.vue?vue&type=template&id=5be7431e&scoped=true&"
import script from "./inc_person_step_4.vue?vue&type=script&lang=js&"
export * from "./inc_person_step_4.vue?vue&type=script&lang=js&"
import style0 from "./inc_person_step_4.vue?vue&type=style&index=0&id=5be7431e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be7431e",
  null
  
)

export default component.exports